import { render, staticRenderFns } from "./LanceDesempate.vue?vue&type=template&id=99836342&scoped=true"
import script from "./LanceDesempate.vue?vue&type=script&lang=js"
export * from "./LanceDesempate.vue?vue&type=script&lang=js"
import style0 from "./LanceDesempate.vue?vue&type=style&index=0&id=99836342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99836342",
  null
  
)

export default component.exports